<section #linkedEntitiesPopupContainer>
  <div class="triangle-up"></div>
  <section class="popup-container">
    <div class="popup-header">
      <div class="header-left">
        <mat-icon class="material-icons-outlined">link</mat-icon>
        <span class="heading-underline">Associate entities to this call</span>
      </div>
      <button mat-button (click)="clearAllLinkedEntities()">CLEAR ALL</button>
    </div>
    <div class="popup-content">
      @if (isLoading) {
        <div class="loading-container">
          <span>Loading linked entities...</span>
        </div>
      }
      @if (!isLoading) {
        <table class="table table-striped full-width">
          <tbody>
            @for (entity of entities.value; track entity) {
              <tr class="entity-item">
                <td class="entity-cell">
                  <i [class]="getEntityIcon(entity.entityType) + ' entity-icon'" (click)="openEntityInBowlingAlley(entity, $event)"></i>
                  <span class="entity-id" (click)="openEntityInBowlingAlley(entity, $event)">{{ entity.id }}</span>
                  <span class="entity-name" (click)="openEntityInBowlingAlley(entity, $event)">{{ entity.name }}</span>
                  <mat-icon (click)="openEntityInBowlingAlley(entity, $event)" class="open-icon" title="Open in Bullhorn">launch</mat-icon>
                </td>
                <td class="close-cell">
                  <mat-icon fontIcon="close" (click)="removeLinkedEntity(entity, $event)" class="remove-icon"></mat-icon>
                </td>
              </tr>
            }
            @if (entities.value.length === 0) {
              <tr class="no-entities">
                <td colspan="2">
                  <span>No linked entities found</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
    <div class="popup-actions">
      <span>Add entity</span>
      <div class="entity-picker-wrapper">
        <app-entity-picker
          (keydown.enter)="$event.preventDefault()"
          (selected)="selectEntity($event)">
        </app-entity-picker>
      </div>
    </div>
  </section>
</section>
